module.exports = __webpack_public_path__ + "static/media/paper26.87cfc5dd.jpg";